import firebase from 'firebase/app'
import db from '../../db'
import defaultFaces from './defaultFaces'

/*
  - Downloads each time we log in
  - Stores everything we need to display the "chats" page
  - Stores all face data used in chats (and uploaded faces)

  chats: {
      myPublishedChatId:{faceIds:[], name:'', modified:''}
  }
  faces: {
      other: {
          'someoneElses':{thumb:'', apng:''}
      }
      uploads: {
          'myUpload': {thumb:'', apng:''}
      }
  }
  modified: ''
*/

const userdocHelper = {
  getUpdatedUserDoc: function ({ commit, dispatch, state }, chatIdData) {
    var userdoc = JSON.parse(JSON.stringify(state.userdoc))
    if (!userdoc.chats) {
      userdoc.chats = {}
    }
    if (!userdoc.faces) {
      userdoc.faces = {}
    }
    if (!userdoc.faces.uploads) {
      userdoc.faces.uploads = {}
    }
    if (!userdoc.faces.other) {
      userdoc.faces.other = {}
    }
    userdoc.modified = firebase.firestore.Timestamp.now()
    if (chatIdData) {
      var id = chatIdData.chatId
      var chat = chatIdData.data
      if (chat === null) {
        // If we are deleting the chat, we set it as null
        if (id in userdoc.chats) {
          delete userdoc.chats[id]
        }
      } else if (id && chat) {
        if (!chat.title) {
          chat.title = ''
        }
        var faces = {}
        for (var fid in chat.faces) {
          faces[fid] = {}
        }
        userdoc.chats[id] = {
          firestore: {
            modified: chat.firestore.modified
          },
          faces: faces,
          title: chat.title
        }
        var faceIds = Object.keys(faces)
        for (var i = 0; i < faceIds.length; ++i) {
          var faceId = faceIds[i]
          if (faceId in state.localFaces) {
            throw new Error('can not publish with private face')
          } else if (faceId in state.userdoc.faces.uploads) {
            // console.log('Using uploaded face...already there no need to store again')
          } else if (faceId === 'default') {
            // console.log('default face')
          } else if (faceId in defaultFaces.faces) {
            // console.log('included face: ' + faceId)
          } else if (faceId in chat.faces) {
            // console.log('Borrowed face')
            userdoc.faces.other[faceId] = {thumb: chat.faces[faceId].thumb, apng: chat.faces[faceId].apng}
          } else {
            console.warn('Unknown face: ' + faceId)
          }
        }
      }
    }
    var deletedOther = []
    var deletedUploads = []
    var otherFaces = {}
    for (var chatId in userdoc.chats) {
      var ids = Object.keys(userdoc.chats[chatId].faces)
      if (chatIdData && chatIdData.data && chatIdData.data.faces && chatIdData.chatId === chatId) {
        ids = Object.keys(chatIdData.data.faces)
      }
      for (i = 0; i < ids.length; ++i) {
        otherFaces[ids[i]] = 1
      }
    }
    for (var other in userdoc.faces.other) {
      if (!(other in otherFaces)) {
        delete userdoc.faces.other[other]
        deletedOther.push(other)
        console.log(other + ' is no longer being used.  Deleting from userdoc.faces.other')
      }
    }
    // eslint-disable-next-line no-redeclare
    for (var other in userdoc.faces.uploads) {
      if (!(other in otherFaces)) {
        delete userdoc.faces.uploads[other]
        deletedUploads.push(other)
      }
    }
    return {userdoc: userdoc, deletedOther: deletedOther, deletedUploads: deletedUploads}
  },
  updateUserDoc: function ({ commit, dispatch, state }, chatIdData) {
    var newUserDocData = userdocHelper.getUpdatedUserDoc({ commit, dispatch, state }, chatIdData)

    // It is assumed the actual deletion of the storageassets is done
    var newUserDoc = newUserDocData.userdoc
    return db.collection('users').doc(firebase.auth().currentUser.uid).update(newUserDoc)
      .then(() => {
        commit('updateUserDoc', newUserDoc)
      })
      .catch((error) => {
        console.warn("Couldn't update userdoc")
        console.warn(error)
      })
  }
}
export default userdocHelper



// WEBPACK FOOTER //
// ./src/store/modules/userdocHelper.js